let globalCurrencyCode = 'INR';

export const setGlobalCurrencyCode = (code) => {
  globalCurrencyCode = String(code || 'INR').trim().toUpperCase() || 'INR';
};

export const getGlobalCurrencyCode = () => globalCurrencyCode;

export function displayCurrency(codeOrSymbol = globalCurrencyCode) {
  if (!codeOrSymbol) return '₹'
  const s = String(codeOrSymbol).trim()
  if (!s) return '₹'
  // Map common currency codes to their symbol for UI display
  if (s.toUpperCase() === 'INR') return '₹'
  // If caller already passed a symbol like '₹', just return it
  if (s.length <= 3 && /[^A-Za-z0-9]/.test(s)) return s
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: s.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).formatToParts(0).find((part) => part.type === 'currency')?.value || s.toUpperCase()
  } catch {
    return s
  }
}

export function formatCurrency(value, code = globalCurrencyCode, options = {}) {
  const amount = Number(value)
  if (!Number.isFinite(amount)) return '—'
  const currencyCode = String(code || globalCurrencyCode || 'INR').trim().toUpperCase()
  try {
    return new Intl.NumberFormat(currencyCode === 'INR' ? 'en-IN' : undefined, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: options.minimumFractionDigits ?? 0,
      maximumFractionDigits: options.maximumFractionDigits ?? 0,
    }).format(amount)
  } catch {
    return `${displayCurrency(currencyCode)} ${Math.round(amount).toLocaleString('en-IN')}`
  }
}

export default displayCurrency
